import React from 'react';
import { Box, Typography, alpha } from '@mui/material';

const SectionHeader = ({ icon: Icon, title, action }) => (
	<Box
		sx={{
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			gap: 1,
			px: { xs: 2, sm: 2.5 },
			py: { xs: 1.5, sm: 2 },
		}}
	>
		<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, minWidth: 0 }}>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					width: 32,
					height: 32,
					borderRadius: 2,
					flexShrink: 0,
					bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
					color: 'primary.main',
				}}
			>
				<Icon sx={{ fontSize: 18 }} />
			</Box>
			<Typography variant="subtitle1" fontWeight={700} noWrap>
				{title}
			</Typography>
		</Box>
		{action}
	</Box>
);

export default SectionHeader;
